import HTTPService from "@/services/http_service.js";

export default class AgendamentoService extends HTTPService {
  resource = "agendamento";

  static build() {
    return new AgendamentoService();
  }

  desmarcarAgendamento(responseFunctions, idAgendamento) {
    this.request(
      responseFunctions,
      "POST",
      `${this.resource}/${idAgendamento}/desmarcar`
    );
  }

  async agendarConsulta(data) {
    return await this.post(this.resource, { ...data });
  }

  async agendarConsultaPrimeiroSlotLivre({
    petId,
    unidadeId,
    medicoId,
    tipoProcedimentoId,
    procedimentoId,
    requisicaoId,
  }) {
    return this.post("agendamento/proximo-slot-livre", {
      petId,
      unidadeId,
      medicoId,
      tipoProcedimentoId,
      procedimentoId,
      requisicaoId,
    });
  }

  async agendarTeleConsulta(data) {
    return await this.post("requisicao/teleconsulta", { ...data });
  }

  async encerrarAgendarTeleConsulta(id_agendamento) {
    return await this.post(
      `agendamento/televet/${id_agendamento}/desmarcar`,
      {}
    );
  }
}
